import { Col, Divider, Flex, Form, FormInstance, Grid } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CalendarDemo from "../../../../../../assets/images/icons/CalendarDemo";
import { CalendarSelector } from "../../../../../../components";
import { PanelDateType } from "../../../../../../components/CalendarSelector/data";
import { useGetSessionSchedule } from "../../../../../../hooks/SessionSchedule/sessionSchedule.hooks";
import { InputRequired } from "../../../../../../validations/validations";
import { FormParams } from "../../data";

type HomeCalendarProps = {
  form: FormInstance;
  params: FormParams | undefined;
};

const HomeCalendar: React.FC<HomeCalendarProps> = ({ params, form }) => {
  const { t } = useTranslation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const [panelDate, setPanelDate] = useState<PanelDateType>();

  const { data: sessionSchedule, isPending } = useGetSessionSchedule(
    { ...panelDate, ...params },
    { enabled: !!panelDate }
  );

  useEffect(() => {
    if (!params) return;
    console.debug("params", params);
  }, [params]);

  return (
    <Col span={screens.md ? 12 : 24}>
      <Form.Item name={"start_date"} hidden />
      <Form.Item name={"end_date"} hidden />

      <Flex align="center" gap={12}>
        <CalendarDemo
          style={{
            fontSize: screens.md ? 32 : 20,
            color: "var(--Neutral-dark-50)",
            minWidth: screens.md ? 32 : 20,
          }}
        />
        <Form.Item
          name={"date"}
          label={t("home.searchbar.date.title")}
          style={{ marginBottom: 0, flex: 1 }}
          rules={[InputRequired(t, "home.searchbar.date.title")]}
          className="filter-form-item"
        >
          <CalendarSelector
            setPanelDate={setPanelDate}
            schedule={sessionSchedule}
            form={form}
            isLoading={isPending}
          />
        </Form.Item>
        {screens.md && (
          <Divider
            type="vertical"
            style={{
              height: "24px",
            }}
          />
        )}
      </Flex>
    </Col>
  );
};

export default HomeCalendar;
